<template>
  <vxe-grid
    auto-resize
    highlight-hover-row
    :data="tableData"
    :toolbar-config="tableToolbar"
    :columns="tableColumns"
    :loading="loading"
    :height="500"
    size="mini"
    resizable
    border
    round
    row-id="noticeOrderCode"
    :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    :radio-config="{
      highlight: true,
      trigger: 'row',
      reserve: true,
      strict: true,
    }"
    @radio-change="(e) => $emit('radio-change', e)"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:pager>
      <slot name="pager"></slot>
    </template>
    <template v-slot:specInfo="{ row }">
      <span>{{ row.spec }} {{ row.specUnit }}</span>
    </template>
    <template v-slot:noticeByName="{ row }">
      <span>{{ row.noticeByName }}</span>
      <br />
      <span>{{ row.noticeTime }}</span>
    </template>
    <template v-slot:noticeOrderStatus="{ row }">
      <el-tag
        v-if="row.v_noticeOrderStatus"
        size="mini"
        :type="row.noticeOrderStatus == 'N' ? '' : 'success'"
      >
        {{ row.v_noticeOrderStatus }}
      </el-tag>
    </template>
    <template v-slot:noticeCostStatus="{ row }">
      <el-tag
        v-if="row.v_noticeCostStatus"
        size="mini"
        :type="
          row.noticeCostStatus == 'N'
            ? ''
            : row.noticeCostStatus == 'P'
            ? 'danger'
            : 'success'
        "
      >
        {{ row.v_noticeCostStatus }}
      </el-tag>
    </template>
    <template v-slot:noticePlanStatus="{ row }">
      <el-tag
        v-if="row.v_noticePlanStatus"
        size="mini"
        :type="
          row.noticePlanStatus == 'N'
            ? ''
            : row.noticePlanStatus == 'P'
            ? 'danger'
            : 'success'
        "
      >
        {{ row.v_noticePlanStatus }}
      </el-tag>
    </template>
    <template v-slot:orderStatus="{ row }">
      <el-tag
        size="mini"
        :type="
          row.orderStatus === 'D' || row.orderStatus === 'T'
            ? 'danger'
            : row.orderStatus === 'R'
            ? 'warning'
            : row.orderStatus === 'Y' ||
              row.orderStatus === 'P' ||
              row.orderStatus === 'C'
            ? 'success'
            : 'light'
        "
      >
        {{ row.v_orderStatus }}
      </el-tag>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'

export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    tablePage: { type: Object, default: () => {} },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
      format: (number) => format(number),
    }
  },
}
</script>
